import { Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NormalizedTransmission } from 'src/modules/generated/api';
import { getLabel, transmissions } from 'src/modules/labels';

import IconValue from './IconValue';

type CarDetailTransmissionProps = {
  transmissionType?: NormalizedTransmission;
};

const TransmissionIcon = (props: {}) => (
  <Icon {...props}>
    <img
      src="/images/icons/transmission-icon.svg"
      alt="Icon for transmission method"
      style={{
        width: '1em',
        height: '1em',
        padding: '2px',
      }}
    />
  </Icon>
);

const CarDetailTransmission = ({ transmissionType }: CarDetailTransmissionProps) => {
  const { t } = useTranslation();
  return (
    <IconValue label={t('car.transmission')} icon={TransmissionIcon} padding>
      {transmissionType ? getLabel(transmissions, transmissionType) : t('common.unavailable')}
    </IconValue>
  );
};

export default CarDetailTransmission;
